namespace Client.InfrastructureTypes

open Fulma

[<RequireQualifiedAccess>]
module Columns =
    let bottomBorder = Columns.CustomClass "bottom-border"